import { publicInstance } from "apis";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import ApiError from "types/ApiError";

interface DTO {
  userName: string;
  name: string;
  email: string;
}

interface Props {
  onError: (error?: string | string[]) => void;
}

const useForgotPassword = ({ onError }: Props) => {
  const fetcher = async (dto: DTO) => {
    const { data } = await publicInstance.post("user/forgotPassword", dto);
    return data;
  };

  const { mutate } = useMutation(fetcher, {
    onError: (error: AxiosError<ApiError>) => {
      onError(error.response?.data.message);
    },
  });

  return mutate;
};

export default useForgotPassword;
